// Tiny History-API router. URLs are /<folder-segments...>/<photoId>.
//
// Folder paths can contain slashes (e.g. "Travel/Japan"), so a URL is ambiguous
// on its own; disambiguation against the catalog happens in the gallery store
// (resolveSegments). This module only encodes/decodes and talks to history.

export function decodePath(pathname: string): string[] {
  return pathname
    .split('/')
    .filter(Boolean)
    .map((s) => safeDecode(s));
}

export function buildPath(folderPath: string, photoId: string | null): string {
  const segments = folderPath.split('/').filter(Boolean).map(encodeURIComponent);
  if (photoId) segments.push(encodeURIComponent(photoId));
  return '/' + segments.join('/');
}

export function pushRoute(folderPath: string, photoId: string | null): void {
  const url = buildPath(folderPath, photoId);
  if (url !== location.pathname) {
    history.pushState({ folderPath, photoId }, '', url);
  }
}

export function replaceRoute(folderPath: string, photoId: string | null): void {
  history.replaceState({ folderPath, photoId }, '', buildPath(folderPath, photoId));
}

function safeDecode(s: string): string {
  try {
    return decodeURIComponent(s);
  } catch {
    return s;
  }
}
